import React, {Fragment, PureComponent} from 'react';
import './index.scss';
import {connect} from 'react-redux';
import {
    getPayParams,
    getUserInfo,
    bindPhoneActionResult,
    sendMessageActionResult,
} from './store/actionCreators';
import {Radio, WingBlank, InputItem, Button, Toast, WhiteSpace} from 'antd-mobile';
import history from './../../utils/history';
import '../../utils/storage';
import {
    TabletOutlined
} from '@ant-design/icons';
import PublicHeader from './../../components/header/index';

class PhoneBind extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            sendMessage: '获取验证码',
            time: 10,
            sendStatus: 0,
        }
        this.init();
    }

    init() {
        this.bindEvent();
    }

    bindEvent() {
        this.handleBindPhone = this.handleBindPhone.bind(this);
        this.handleSendCode = this.handleSendCode.bind(this);
    }

    componentDidMount() {
        let oauthInfo = Storage.Base.getInstance().get('_loginTk');
        if (!oauthInfo) {
            history.push('./login');
            return;
        }
    }

    async handleSendCode() {
        var time = 60;
        var that = this;
        if (this.state.sendStatus === 1) {
            return;
        }

        const data = {
            type: '3',
            smsType: "4",
            phone: this.phoneRef.state.value
        };

        data.phone = data.phone.replace(/\s+/g, "");

        if (!data.phone) {
            Toast.info("请输入手机号码！")
            return;
        }

        const result = await this.props.handleSendCode(data);

        console.log("result", result)
        if (result.status === 200) {
            Toast.success("发送成功");
        } else {
            Toast.fail('网络异常', 1);
        }

        setInterval(function () {
            if (time <= 0) {
                that.setState({
                    sendMessage: '发送验证码',
                })
            }
            else {
                that.setState({
                    sendMessage: time + "s后重新获取",
                    sendStatus: 1
                });
                time--;
            }
        }, 1000);
    }


    async handleBindPhone() {
        var userInfo = Storage.Base.getInstance().get('_loginTk');
        if (userInfo === null) {
            history.push('./login');
            return;
        }
        const data = {
            type: '2',
            phone: this.phoneRef.state.value,
            smsCode: this.validateRef.state.value,
            token: userInfo,
        };
        if (!data.phone) {
            Toast.info("请输入手机号码！")
            return;
        }
        if (!data.smsCode) {
            Toast.info("请输入手机验证码！")
            return;
        }

        const result = await this.props.handleBindPhone(data);
        if (result.status === 200) {
            Storage.Base.getInstance().set("register", true);
            Toast.info("手机号更新成功！")
            setTimeout(() => {
                history.push('./home?tab=Home');
            }, 1000);
        } else {
            Toast.info("绑定失败,请刷新重试.");
        }
    }

    render() {
        const userInfo = this.props;
        const {mobile} = userInfo.userInfo;
        console.log(this.props)
        const {sendMessage} = this.state;

        return (
            <div>
                <PublicHeader title="更换手机号"/>
                <WhiteSpace size="lg"/>
                <WhiteSpace size="lg"/>
                <WhiteSpace size="lg"/>
                <WingBlank size="lg">
                    <InputItem
                        clear
                        ref={el => this.phoneRef = el}
                        placeholder="手机号码"
                        maxLength="11"
                        extra={sendMessage}
                        onExtraClick={this.handleSendCode}
                    >
                    </InputItem>

                    <InputItem
                        clear
                        ref={el => this.validateRef = el}
                        placeholder="验证码">
                    </InputItem>
                    <WhiteSpace size="lg"/>
                    <WhiteSpace size="lg"/>
                    <WhiteSpace size="lg"/>
                    <Button type="primary" onClick={this.handleBindPhone}
                            style={{lineHeight: '50px'}}>更换手机号</Button>
                </WingBlank>
            </div>
        )
    }
}


const mapStateToProps = (userInfo) => {
    return {
        userInfo: userInfo.userInfo.userInfo,
        bindPhone: userInfo.bindPhone
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getUserInfo: (id) => dispatch(getUserInfo({userId: id})),
        handleBindPhone: data => dispatch(bindPhoneActionResult(data)),
        handleSendCode: data => dispatch(sendMessageActionResult(data)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PhoneBind);
